import { render, staticRenderFns } from "./Configuration_Modbus.vue?vue&type=template&id=8bb5f306"
import script from "./Configuration_Modbus.vue?vue&type=script&lang=js"
export * from "./Configuration_Modbus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports